import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Handshake } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";

export default function ContractShortcut({ distributorId }) {
  const [contract, setContract] = useState(null);
  useEffect(() => {
    api.get(`/partner-contracts?distributor_id=${distributorId}&include_inactive=true`)
      .then((r) => { const list = r.data || []; setContract(list.find((c) => c.active) || list[0] || null); })
      .catch(() => setContract(null));
  }, [distributorId]);
  if (!contract) return null;
  return (
    <Button variant="outline" asChild data-testid="distributor-contract-link">
      <Link to={`/partenaires/retribution?contract=${contract.id}`}>
        <Handshake className="w-4 h-4 mr-2" /> Contrat
      </Link>
    </Button>
  );
}
